import { FC } from "react";

interface Props {
    label: string;
    children: React.ReactNode;
}

export const InputWrapper:FC<Props> = ({ label, children }) => {
    return (
        <div>
            <label className="block mb-2 text-sm font-medium">{label}</label>
            {children}
        </div>
    )
}
